import React from 'react';
import PropTypes from 'prop-types';
import { SectionDetailLabel } from '../styles';
import MonthYearSelector from './month-year-selector';
import Loading from '../../../../../shared/loading';
import { usePostUpdateJoinedIndustryAt } from '../../../../../services/profiles/contributor-settings-service';
import defaultOnErrorHandler from '../../../../../shared/default-on-error-handler';

export default function JoinedIndustryAt({ value, onUpdate }) {
  const [{ loading, error }, post] = usePostUpdateJoinedIndustryAt();
  const loadingRef = React.useRef();

  React.useEffect(() => (loadingRef.current[loading ? 'start' : 'stop']()), [loading]);

  React.useEffect(() => {
    error && defaultOnErrorHandler(error, 'Error saving date of joining current role');
  }, [error]);

  const updateDate = mom => {
    post(mom.format()).then(() => onUpdate({ joinedIndustryAt: mom.format() }));
  };

  return (
    <article>
      <SectionDetailLabel>when did you first join the industry?</SectionDetailLabel>
      <MonthYearSelector value={value} onDateSelected={updateDate} yearOnly />
      <Loading variant="sip" ref={loadingRef} />
    </article>
  );
}

JoinedIndustryAt.propTypes = {
  value: PropTypes.string,
  onUpdate: PropTypes.func,
};

JoinedIndustryAt.defaultProps = {
  value: null,
  onUpdate: () => null,
};
